var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3877 17.7083H21.6048L20.1389 16.2449C19.7413 15.848 19.518 15.3097 19.518 14.7484V11.4583C19.518 8.73705 17.7759 6.42197 15.3443 5.56397V5.20833C15.3443 4.05774 14.41 3.125 13.2575 3.125C12.105 3.125 11.1707 4.05774 11.1707 5.20833V5.56397C8.7391 6.42197 6.99699 8.73705 6.99699 11.4583V14.7484C6.99699 15.3097 6.77365 15.848 6.37609 16.2449L4.91016 17.7083H10.1272M16.3877 17.7083V18.75C16.3877 20.4759 14.9863 21.875 13.2575 21.875C11.5287 21.875 10.1272 20.4759 10.1272 18.75V17.7083M16.3877 17.7083H10.1272",
    stroke: "#3F3F46",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.539b5aaba3e2ac88fd19a7542d102a37.svg";
export { ForwardRef as ReactComponent };